import { useSearchParams } from "react-router-dom"

interface IRouteParams {
    param: string
    value: string
}

const useRouteParams = (): IRouteParams[] => {
    const [searchParams] = useSearchParams()

    return Array.from(searchParams.entries()).map(([key, value]) => ({
        param: key,
        value: value,
    }))
}

export default useRouteParams
